let initialised = false;
const data: {[key: string]: any} = {};

function init () {
  const elements = document.querySelectorAll<HTMLElement>('.template-data');

  for (const element of Array.from(elements)) {
    Object.assign(data, element.dataset);
  }
}

function templateData (accessor: string, fallback: any = undefined): any {
  if (!initialised) {
    init();
    initialised = true;
  }

  return accessor in data ? data[accessor] : fallback;
}


export default templateData;
